// Export without redux connection
import TutorialPage3 from "./TutorialPage3";

export default TutorialPage3;
